import React, { Fragment } from "react";

import TablaFiltro from "../../../components/UI/tablaFiltro/tablaFiltroSort";

import { Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronUp,
  faChevronDown,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

import CajaTexto from "../../../components/UI/cajaTexto/cajaTexto.jsx";
import ComboBox from "../../../components/UI/comboBox/combobox.jsx";

export default props => {

  const {
    Datos,
    listaSucursalesZona,
    columnasSucursalesZona,
    listaSucursales,
    selectedSucursal
  } = props;

  const selectRow = {
    clickToSelect: true,
    onSelect: (row, isSelected) => { props.onRowClick(isSelected ? row.Zona_Orden : 0); },
    mode: "radio",
    style: { background: "#e2f3f9" },
    hideSelectColumn: true
  };

  const cellEdit = { mode: "click", autoSelectText: true, blurToSave: true };
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      //props.onRowClick(row.Zona_Orden);
    }
  };

  return (
    <Fragment>
      <Row>
        <Col xs={6}>
          <h6>Sucursales</h6>
        </Col>
      </Row>
      <Row>
        <Col>
          <CajaTexto
            id="NombreZona"
            type="text"
            label="Zona:"
            value={Datos.Nombre.value}
            attributes={Datos.Nombre.attributes}
          />
        </Col>
        <Col>
          <ComboBox
            id="Sucursal"
            label={Datos.Sucursal.attributes.label}
            attributes={Datos.Sucursal.attributes}
            value={selectedSucursal}
            datos={listaSucursales}
            onChange={props.onhandleSelectedOption}
          />
        </Col>
        <div className="col-auto mt-4 pt-2">
          <div className="tooltip2">
            <span className="tooltiptext2">Agregar</span>
            <button className="btn btn-link buscar" onClick={props.onClickAgregar}>
              Agregar
            </button>
          </div>
        </div>
      </Row>
      <Row className="mt-3">
        <Col className="text-right">
          <div className="tooltip2">
            <span className="tooltiptext2">Mover Arriba</span>
            <Button variant="success" onClick={props.onClickMoverArriba}>
              <FontAwesomeIcon icon={faChevronUp} />
            </Button>
          </div>
            &nbsp;
            <div className="tooltip2">
            <span className="tooltiptext2">Mover Abajo</span>
            <Button variant="success" onClick={props.onClickMoverAbajo}>
              <FontAwesomeIcon icon={faChevronDown} />
            </Button>
          </div>
            &nbsp;
            <div className="tooltip2">
            <span className="tooltiptext2">Eliminar</span>
            <Button variant="success" onClick={props.onClickEliminar}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="mt-4">
          <div className="ingreso-info">
            <TablaFiltro
              columnas={columnasSucursalesZona}
              datos={listaSucursalesZona}
              keyField={"Zona_Orden"}
              modo={cellEdit}
              rowEvents={rowEvents}
              selectRow={selectRow}
              paginaActual={props.paginaActual}
              onPageChange={props.onPageChange}
              onSizePerPageChange={props.onSizePerPageChange}
            />
          </div>
        </Col>
      </Row>
      <hr />
      <Row className="mb-3">
        <Col className="text-right">
          <div className="tooltip2">
            <span className="tooltiptext2">Cancelar</span>
            <Button variant="secondary" onClick={props.volverAtras}>
              Cancelar
              </Button>
          </div>
            &nbsp;
            <div className="tooltip2">
            <span className="tooltiptext2">Guardar</span>
            <Button
              variant="primary"
              onClick={props.ingresarDatosSucursalesPorZona}
            >
              Guardar
              </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};
